import React from 'react';
import '../style.css'
import styles from '../index.module.css'
import tick from '../../../../assets/journaler/solutions/CheckCircle.png'
import imgOne from '../../../../assets/journaler/solutions/iconOne.png'
import imgTwo from '../../../../assets/journaler/solutions/iconTwo.png'
import imgThree from '../../../../assets/journaler/solutions/iconThree.png'
import clsx from 'clsx'

const content = [
  {
    img: imgOne,
    title: 'Accounting Integration',
    des: [
      'Export crypto data directly into Xero and QuickBooks.',
      'Ensure crypto activity flows into the general ledger.',
    ],
  },
  {
    img: imgTwo,
    title: 'Multi-Client & Multi-Wallet Setups',
    des: [
      'Manage multiple client data within a single platform.',
      'Scales easily across accounting firms and client volumes',
    ],
  },
  {
    img: imgThree,
    title: 'Audit & Compliance Trails',
    des: [
      'Maintain full transaction traceability for every crypto record.',
      'Support internal reviews, external audits, and tax preparation with confidence.',
    ]
  }
]

const ReportingFeature = ({ img, title, des }) => (
  <div className={clsx('col-lg-4 col-sm-12', styles.reportingFeature)}>
    <div className={styles.reportingImageContainer}>
      <img className={clsx('img-fluid', styles.reportingImage)} src={img} alt={title} />
    </div>
    <div className={styles.headerReport}>
      <div className={clsx(styles.titleReport, styles.reportingTitle)}>
        {title}
      </div>
      {des.map((item, index) => (
        <div key={index} className={clsx('row', styles.reportingFeatureItem)}>
          <div className={clsx('col col-1', styles.reportingTickContainer)}>
            <img src={tick} alt='tick' className={styles.reportingTick} />
          </div>
          <div className={clsx('col', styles.subReport)}>
            <p className={styles.reportingFeatureText}>{item}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
)

const KeyFeatures = ({ data }) => (
  <div className={clsx('bgcolor-dark', styles.keyFeatureSectionContainer)}>
    <div className='container'>
      <h1 className={clsx('text-center', styles.titleKeyFeature)}>{data.title}</h1>
      <div className='w-100'>
        <div className='row'>
          {
            data.content.map((item, index) => (
              <ReportingFeature
                key={index}
                img={item.img}
                title={item.title}
                des={item.des}
              />
            ))
          }
        </div>
      </div>
    </div>
  </div>
)

export default KeyFeatures